import React, { useState, useEffect } from "react";
import { Alert, ProgressBar } from "react-bootstrap";

const FormAlert = ({ errors, dismissible, isLoading }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (errors) setShow(true);
  }, [errors]);

  if (!errors && !isLoading) {
    return null;
  }

  if (isLoading) {
    return (
      <>
        <ProgressBar animated now={100} />
        <br />
      </>
    );
  }

  const formStatusErrors = [];

  Object.keys(errors).forEach((key) => {
    if (key === "message" || !Number.isNaN(key)) formStatusErrors.push(errors[key]);
  });

  if (!formStatusErrors.length || !show) return null;

  return (
    errors && (
      <Alert variant="danger">
        {dismissible && (
          <button type="button" className="close" onClick={() => setShow(false)} aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        )}
        <ul>
          {formStatusErrors.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </Alert>
    )
  );
};

export default FormAlert;
